module.exports = __webpack_public_path__ + "img/bgr-home-mobile.249233ff.png";